import { render, staticRenderFns } from "./ContentRoot.vue?vue&type=template&id=4d22cb96"
import script from "./ContentRoot.vue?vue&type=script&lang=ts"
export * from "./ContentRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports